/**
 * Copia texto para a área de transferência, com alternativa para HTTP.
 *
 * `navigator.clipboard` só existe em contexto seguro — HTTPS ou localhost. Num
 * CRM acessado pelo IP da rede local (`http://192.168.2.247:3000`), o objeto
 * vem `undefined` e `navigator.clipboard.writeText(...)` estoura antes de
 * copiar qualquer coisa. O aviso de sucesso nem chega a aparecer, e para quem
 * está usando parece que o botão simplesmente não faz nada.
 *
 * Quando a API moderna não está disponível, caímos no `execCommand("copy")`.
 * Ele é obsoleto e um dia sai dos navegadores, mas hoje é o único caminho que
 * funciona em página servida por HTTP — e é exatamente onde o CRM roda na
 * rede interna do cliente.
 *
 * @param {string} texto
 * @returns {Promise<boolean>} se conseguiu copiar
 */
const copyToClipboard = async (texto) => {
  const valor = String(texto ?? "");
  if (!valor) return false;

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(valor);
      return true;
    } catch (err) {
      // Permissão negada ou aba sem foco: ainda vale tentar o caminho antigo.
    }
  }

  try {
    const area = document.createElement("textarea");
    area.value = valor;
    // `readonly` evita o teclado virtual aparecer no celular; sair da tela
    // com `position: fixed` evita o salto de rolagem que `display:none` não
    // resolveria — elemento escondido não é selecionável.
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.top = "-1000px";
    area.style.opacity = "0";

    document.body.appendChild(area);
    area.select();
    // iOS ignora `select()` sozinho em alguns casos.
    area.setSelectionRange(0, valor.length);

    const copiou = document.execCommand("copy");
    document.body.removeChild(area);
    return copiou;
  } catch (err) {
    return false;
  }
};

export default copyToClipboard;
